import React from "react";
import { useLocation } from "react-router-dom";

class RouteLoadErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    console.error("Unable to load ERP page", error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div role="alert" className="p-10 text-slate-700">
          <p className="font-medium">This page could not be loaded.</p>
          <p className="mt-1 text-sm text-slate-500">Check your connection and try again.</p>
          <button
            type="button"
            className="mt-4 rounded-md bg-slate-900 px-4 py-2 text-sm font-medium text-white"
            onClick={() => window.location.reload()}
          >
            Reload page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default function RoutePage({ children }) {
  const location = useLocation();
  return (
    <RouteLoadErrorBoundary key={`${location.pathname}${location.search}`}>
      <React.Suspense fallback={<div role="status" className="p-10 text-slate-500">Loading…</div>}>
        {children}
      </React.Suspense>
    </RouteLoadErrorBoundary>
  );
}
